import React from 'react';
import { FieldDisplayProps } from '../../types';

export const TextFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  return (
    <div
      className="pill custom-field-pill editable"
      onDoubleClick={handleClick}
      onClick={handleClick}
    >
      {value}
    </div>
  );
};

export default TextFieldDisplay;
